import { ref } from "vue"

// A single screen-reader live region (rendered once in App.vue) that any part of the app can
// write to. Use it to announce dynamic changes that have no natural focus move — items added to
// the cart, search result counts, etc. Announcements are polite (they don't interrupt).
const message = ref("")
let pending = []
let scheduled = false

function announce(text) {
  if (!text) {
    return
  }
  // Collect every message fired in the same frame and emit them as ONE live-region update,
  // joined in call order. Otherwise two announcements triggered by the same action — e.g.
  // "12 items in cart" (cart watcher) and "No more units available" (quantity button) — would
  // race, and the second would overwrite the first before the screen reader speaks it.
  pending.push(text)
  if (scheduled) {
    return
  }
  scheduled = true
  // Clear first so a repeated identical message still registers as a DOM change (and is spoken).
  message.value = ""
  requestAnimationFrame(() => {
    message.value = pending.join(". ")
    pending = []
    scheduled = false
  })
}

export default { message, announce }
